<template>
  <ol>
    <li>请在 {{ date }} 前主动添加客服，提供孩子基本学习情况，以便合理安排试听老师</li>
    <li>请确保孩子听完整节试听课，与老师互动</li>
    <li>仅有 1 次试听机会，临时或中途取消将导致优学卡失效</li>
  </ol>
</template>

<script>
export default {
  props: ["date"]
}
</script>
<style lang="scss" scoped>
ol {
  counter-reset: li;
  margin: 0;
  padding: 0;
  font-size: 0.8rem;
}
ol > li {
  position: relative;
  padding-left: 15px;
  margin-block-end: 8px;
}
ol > li:before {
  content: counter(li);
  counter-increment: li;
  position: absolute;
  left: 0px;
  line-height: 23px;
  color: $black;
  font-size: 18px;
  font-weight: 300;
  @include avenir();
  opacity: 0.5;
}
</style>